import React, { useEffect, useState } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import whiteListService from './whitelistService';

export function WhitelistForm(prop) {
    const [whiteListSer] = useState(new whiteListService());
    const [ipId, setIpId] = useState(null);
    const [ipStartRange, setStartRange] = useState(null);
    const [ipEndRange, setEndRange] = useState(null);

    const [ipStartRangeValid, setStartRangeVaild] = useState(true);
    const [ipEndRangeVaild, setEndRangeVaild] = useState(true);    

    const [ipDescription, setDescription] = useState(null);

    const { toggleModel, data, setWhiteListData, rowData, customerId } = prop;

    const onComponentLoad = () => {
        if (rowData) {
            setIpId(rowData.id);
            setStartRange(rowData.ipStart);
            setEndRange(rowData.ipEnd);
            setDescription(rowData.description);
        }
    };

    useEffect(() => {
        onComponentLoad(); // this will fire only on first render
    }, []);

    const saveWhiteListData = async () => {
        event.preventDefault();

        if (rowData) {
            await whiteListSer.saveOrUpdateWhitelist({
                id: rowData.id,
                customerId: customerId,
                ipStart: ipStartRange,
                ipEnd: ipEndRange,
                description: ipDescription,
            });
        } else {
            await whiteListSer.saveOrUpdateWhitelist({
                customerId: customerId,
                ipStart: ipStartRange,
                ipEnd: ipEndRange,
                description: ipDescription,
            });
        }
        setWhiteListData(await whiteListSer.getAllWhitelistByCustomerId(customerId));
        toggleModel();
    };

    const deleteWhiteListData = async () => {
        event.preventDefault();
        await whiteListSer.deleteWhitelist(ipId);
        setWhiteListData(await whiteListSer.getAllWhitelistByCustomerId(customerId));
        console.log(data);
        toggleModel();
    };

    const ipRejex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    
    const handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        
        if (name === 'ipStart') {
            if(ipRejex.test(value) || value.length === 0){
                setStartRangeVaild(true);
            } else{
                setStartRangeVaild(false);
            }
             setStartRange(value);
        }
        if (name === 'ipEnd') {
            if(ipRejex.test(value) || value.length === 0){
                setEndRangeVaild(true);
            } else{
                setEndRangeVaild(false);
            }
            setEndRange(value);
        }
        if (name === 'description') {
            setDescription(value);
        }
    };

    const onBlurIP = (event) => {
        event.preventDefault();

        const startIp = ipStartRange && ipStartRange.split(".");
        const endIp = ipEndRange && ipEndRange.split(".");

        if(ipEndRange && Number(startIp[0]) > Number(endIp[0]) && Number(startIp[0]) != Number(endIp[0])){
            setEndRangeVaild(false);
        }else if (ipEndRange && Number(startIp[0]) == Number(endIp[0])){
            if(Number(startIp[1]) > Number(endIp[1])){
                setEndRangeVaild(false);
            }else if(Number(startIp[1]) == Number(endIp[1])){
                if(Number(startIp[2]) > Number(endIp[2])){
                    setEndRangeVaild(false);
                }else if(Number(startIp[2]) == Number(endIp[2])){
                    if(Number(startIp[3]) > Number(endIp[3])){
                        setEndRangeVaild(false);
                    }
                }
            }
        }

    }
    
    return (
        <div>
            <Form  onSubmit={saveWhiteListData} noValidate>
                <Row className="mt-3">
                    <Col md={12}>
                        <Form.Group className="mb-2">
                            <Form.Label>IP Start Range</Form.Label>
                            <Form.Control
                                type="text"
                                id="ipStart"
                                name="ipStart"
                                placeholder="Start Range"
                                autoComplete="none"
                                className="ipStart"
                                required
                                onChange={handleChange}
                                value={ipStartRange}
                                pattern = '/^[0-9]*\.?[0-9]*$/'
                                onBlur={onBlurIP}
                            />
                            { !ipStartRangeValid && <p className='error'>
                                 Please enter a valid ip address.
                            </p>
                            }
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={12}>
                        <Form.Group className="mb-2">
                            <Form.Label>IP End Range</Form.Label>
                            <Form.Control
                                type="text"
                                id="ipEnd"
                                name="ipEnd"
                                placeholder="End Range"
                                autoComplete="none"
                                value={ipEndRange}
                                className="ipEnd"
                                required
                                onChange={handleChange}
                                onBlur={onBlurIP}
                            />
                           { !ipEndRangeVaild && <p className='error'>
                            Please enter a valid ip address and end ip range should be greater start range.
                             </p>
                            }
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={12}>
                        <Form.Group className="mb-2">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type="text"
                                id="description"
                                name="description"
                                placeholder="Description"
                                autoComplete="none"
                                value={ipDescription}
                                className="description"
                                required
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={4}>
                        <Button
                            type="submit"
                            className="submit-btn"
                            variant="primary"
                            size="lg"
                            id="submit-btn"
                            block
                            disabled={!(ipDescription && ipEndRange && ipStartRange && ipEndRangeVaild && ipStartRangeValid)}
                        >
                            Save
                        </Button>
                    </Col>
                    {rowData && (
                        <Col md={4}>
                            <Button
                                type="submit"
                                className="submit-btn"
                                variant="primary"
                                size="lg"
                                id="submit-btn"
                                block
                                disabled={!(ipDescription && ipEndRange && ipStartRange && ipEndRangeVaild && ipStartRangeValid)}
                                onClick={deleteWhiteListData}
                            >
                                Delete
                            </Button>
                        </Col>
                    )}
                    <Col md={4}>
                        <Button
                            type="submit"
                            className="submit-btn"
                            variant="primary"
                            size="lg"
                            id="submit-btn"
                            onClick={toggleModel}
                        >
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}

export default WhitelistForm;
